import { useEffect, useState } from "react";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { MapPin } from "lucide-react";
import { isLocationRecordEnabled, setLocationRecordEnabled } from "@/lib/deviceLocation";

// Feature 19 — opt-in for the Optional Device Location Record. Default OFF, device-only.
export function LocationRecordToggle() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => { setEnabled(isLocationRecordEnabled()); }, []);

  const toggle = (val) => {
    setLocationRecordEnabled(val);
    setEnabled(val);
    toast.success(val ? "Device location will be recorded with new captures" : "Device location recording is off");
  };

  return (
    <div className="w-full rounded-2xl border border-[#E2E8F0] bg-white p-6" data-testid="location-record-section">
      <h2 className="font-heading text-lg font-semibold text-navy flex items-center gap-2"><MapPin size={18} /> Device location</h2>
      <div className="mt-4 flex items-center justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-navy">Record device location with new captures</p>
          <p className="text-xs text-[#94A3B8]">
            When on, your browser asks permission once and attaches a private location record to new photos and
            walkthrough videos. Location is supplied by your device, stays owner-only, and is never shown in shared
            reports, exports or public verification. Denying or turning this off never blocks capture.
          </p>
        </div>
        <Switch data-testid="location-record-switch" checked={enabled} onCheckedChange={toggle} />
      </div>
    </div>
  );
}
